import { personalInfoQueryOptions } from '@/hooks/api';
import { useNosIdMutation } from '@/hooks/api/base.hooks';
import { api } from '@/portal-api.definition';
import { ActionType, ErrorCodes, useI18n, useToast } from '@nosinovacao/nosid-mfe-common';

export function useEnable2FA() {
  const toast = useToast();
  const { t } = useI18n();
  return useNosIdMutation({
    mutationFn: ({ code, target }: { code: string; target: string }) =>
      api.post('/api/v1/security/enable-2factor-auth', {
        Code: code,
        TargetId: target,
        Type: 'Sms',
      }),
    ignoreSnackbarForErrors: [ErrorCodes.InvalidSecurityCode],
    successLogAction: () => ({ ActionType: ActionType.Submit }),
    errorLogAction: () => ({ ActionType: ActionType.Submit }),
    onSuccess: (_res, _input, _mutateRes, { client }) => {
      client.setQueryData(personalInfoQueryOptions.queryKey, (old) =>
        old ? { ...old, TwoFactorAuthEnabled: true } : old,
      );
      toast.show('success', t('Common.SnackBar.TwoFactorAuthEnabled'));
    },
  });
}
